import { render, staticRenderFns } from "./talk_myfagao.vue?vue&type=template&id=196b0f68&scoped=true&"
import script from "./talk_myfagao.vue?vue&type=script&lang=js&"
export * from "./talk_myfagao.vue?vue&type=script&lang=js&"
import style0 from "./talk_myfagao.vue?vue&type=style&index=0&id=196b0f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b0f68",
  null
  
)

export default component.exports